import { type FC } from 'react';

import { CardJoinElectronicTradingButtonContainer } from '@/microfrontends/listing/shared/containers/CardJoinElectronicTradingButtonContainer';
import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { CardChatButtonWideContainer } from '../../../CardChatButtonWideContainer';
import { CardContactsButtonDesktopContainer } from '../../../CardContactsButtonContainer';
import { ContactActionsLayout } from '../ContactActionsLayout';
import { PublisherMoreOffersContainer } from '../PublisherMoreOffers';

export const ContactActions: FC = () => {
  const { config } = useListingAppContext();
  const { tradingLink } = useCardOfferDataContext();

  /**
   * @todo Удалить фича-тогл
   * @description Данный функционал появился в задаче CD-187914, будет удалён в задаче CD-188067
   */
  const electronicTradingEnabled = config.getStrict<boolean>('search-frontend.ElectronicTrading.Enabled');
  const isELectronicTradingAvailable = electronicTradingEnabled && !!tradingLink;

  return (
    <ContactActionsLayout
      chatButton={<CardChatButtonWideContainer />}
      joinElectronicTradingButton={
        isELectronicTradingAvailable ? (
          <CardJoinElectronicTradingButtonContainer buttonText="Принять участие в торгах" />
        ) : null
      }
      phoneButton={<CardContactsButtonDesktopContainer />}
      showMoreOffers={<PublisherMoreOffersContainer />}
    />
  );
};
